import Tooltip from '@mui/material/Tooltip';

import { ProtocolStatus } from 'api/v1/data-contracts';
import { CheckmarkCircle } from 'assets/volvoIcons/Control/CheckmarkCircle';

export const HealthCheckProtocolStatusSymbol = ({
	status,
}: {
	status: ProtocolStatus;
}): React.JSX.Element | null => {
	switch (status) {
		case 'Finalized':
			return (
				<Tooltip title={'Finalized'}>
					<span>
						<CheckmarkCircle color="success" />
					</span>
				</Tooltip>
			);
		case 'Draft':
			return (
				<Tooltip title={'Initiated'}>
					<span>
						<CheckmarkCircle color="warning" />
					</span>
				</Tooltip>
			);
		default:
			return null;
	}
};
